import {
  ALLOWED_MANAGED_IMAGE_CONTENT_TYPE_SET,
  MAX_MANAGED_IMAGE_SIZE_BYTES,
  MAX_MANAGED_IMAGE_SIZE_ERROR_MESSAGE,
} from '@azymmetric/shared/attachments/attachment.constants';

export const TECHNOLOGY_IMAGE_ACCEPT = 'image/png,image/jpeg,image/webp,image/svg+xml';
export const TECHNOLOGY_IMAGE_FIELD_DESCRIPTION = 'Formats: JPEG, PNG, SVG, WEBP. Maximum file size: 5MB.';
export const TECHNOLOGY_IMAGE_FORMAT_ERROR_MESSAGE = 'Image must be JPEG, PNG, SVG, or WEBP.';

export const validateTechnologyImageFile = (file: File): string | undefined => {
  if (!ALLOWED_MANAGED_IMAGE_CONTENT_TYPE_SET.has(file.type)) {
    return TECHNOLOGY_IMAGE_FORMAT_ERROR_MESSAGE;
  }

  if (file.size > MAX_MANAGED_IMAGE_SIZE_BYTES) {
    return MAX_MANAGED_IMAGE_SIZE_ERROR_MESSAGE;
  }

  return undefined;
};
